import { isNullOrEmpty } from "../../../../../../react-core/Utils/Arrays";
import { Money } from "../../../../../../Wrap/Core/DataTypes/Money";
import { TransferISTSelection } from "../../../../../../Wrap/Models/Models/InstrumentSelection/TransferISTSelection";

export class TransferHelper {
    static getTransferInvestmentTotal(investments: Array<TransferISTSelection>, residualCash: Money) {
        let total = 0;
        if (!isNullOrEmpty(investments)) {
            investments.forEach((investment) => {
                total += investment?.Investment?.UnitPrice?.Amount * investment.Units;
            });
        }
        if (residualCash?.Amount > 0) {
            total += residualCash.Amount;
        }
        return total;
    }
}
